// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { makeModulationSchemeLabel } from 'redux/helpers'
import getModulationConfig from './getModulationConfig'
import getRadioModulation from './getRadioModulation'

import {
  castToString,
  roundAndCastToString,
} from 'helpers/reduxFormFunctions'

// based on the modulation calculations, segment end modulation and radio modulation, make some info here.
const makeModCalcTotals = (index, modCalcBase, radioModulationConfigurations, modulations) => {
  // from the modulations calculations
  const eirp = roundAndCastToString(modCalcBase.eirp, 2) || '-'
  const rsl = roundAndCastToString(modCalcBase.rsl, 2) || '-'

  // from the segment end modulation
  const {
    power,
    radioModulationId,
  } = getModulationConfig(radioModulationConfigurations, modCalcBase.segmentEndModulationId)

  // from the radio modulation itself get some infos
  // NOTE - since Site 1's RSL is actually a reflection of site 2's configuration,
  // each row of RSL data reflects a frequency/polarization pair from the opposite end.
  // since we can have variable number of these between the two path ends,
  // it is possible we will have more 'rows' of RSL data than there are segmentEndModulationIds.
  // So, allowing for rm to be an empty object provides consideration for one these un-paired rows.
  const rm = getRadioModulation(modulations, radioModulationId) || {}
  // for the situation described above, don't try to run makeModulationSchemeLabel
  const modulationSchemeDescription = (
    Object.keys(rm).length
      ? makeModulationSchemeLabel(rm.modulationScheme)
      : ''
  )
  const emissionDesignator = castToString(rm.emissionDesignator)
  const throughput = roundAndCastToString(rm.throughput, 2)

  // below we have hiddenIndex and index.
  // this is because you can have rows of RSL values without a correspondig
  // segment end modulation. when that happens you don't want to show an index
  // value but React still needs a unique value for tracking DOM updates.

  return {
    eirp,
    emissionDesignator,
    hiddenIndex: index, // this is used to create unique ids and keys in react.
    index: radioModulationId ? index + 1 : '', // this is displayed in the UI
    modulationSchemeDescription,
    power,
    rsl,
    throughput,
    uniqueId: 'hiddenIndex',
  }
}

export default makeModCalcTotals
